import { useGetApprovableTargetQuery } from 'features/comments/approvalApi';

/**
 * Hook to get an approvable target
 * @param {string} id
 * @returns {import('../../../models/approval.models').ApprovableTarget | undefined}
 */
export function useGetApprovableTarget(id) {
    const results = useGetApprovableTargetQuery(id, {
        skip: id === undefined,
    });

    return results?.currentData;
}
